module.exports = __webpack_public_path__ + "img/egg.af60de10.jpeg";